import { Grid, Card } from '@material-ui/core';
import styled, { css } from 'styled-components';

export const Wrapper = styled(Grid)`
  margin: auto;

  .MuiCard-root {
    overflow: auto !important;
  }
`;

export const WrapperButtons = styled(Grid)`
  button:not(:last-child) {
    margin-bottom: 1.3rem;
  }
`;

export const WrapperPaper = styled(Card)`
  width: 23rem;
  height: ${({ grid }) => (grid ? '100%' : '21rem')};

  ${({ maxWidth }) =>
    maxWidth &&
    css`
      width: ${maxWidth}rem;
    `}

  overflow: auto;
`;
